import axios from 'axios';
import { LOGOUT_URL, SEND_LOG_URL } from '@/constants';
import { sendLog } from '@/api/logger';
import { getResponseErrorText, getSendLogParams } from '@/utils/common';
import { BASE_API_URL } from '@/api/request';
import { GET_AUTHORIZATION_CODE_URL } from '@/constants';

const INTERCEPTOR_SEND_LOG_URL = `${BASE_API_URL}${SEND_LOG_URL}`;
const INTERCEPTOR_GET_AUTHORIZATION_CODE_URL = `${BASE_API_URL}${GET_AUTHORIZATION_CODE_URL}`;
const INTERCEPTOR_LOGOUT_URL = `${BASE_API_URL}${LOGOUT_URL}`;

// Add a response interceptor
axios.interceptors.response.use(
  async function (response) {
    if (
      response.config.url &&
      ![
        INTERCEPTOR_SEND_LOG_URL,
        INTERCEPTOR_GET_AUTHORIZATION_CODE_URL,
        INTERCEPTOR_LOGOUT_URL,
      ].includes(response.config.url)
    ) {
      await sendLog({
        ...getSendLogParams(),
        integration: {
          url: response.config.url,
          status: String(response.status),
        },
      });
    }
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    const url = error.response?.config?.url;
    if (url && url !== INTERCEPTOR_SEND_LOG_URL) {
      await sendLog({
        ...getSendLogParams(),
        integration: {
          url,
          status: String(error.response?.status),
        },
        // error: getResponseErrorText(error),
      });
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
